module.exports = __webpack_public_path__ + "media/application/images/svgs/book-b0f7f2f1b4f5376bbfa33ab3dfc9e4c2.svg";